import { render, staticRenderFns } from "./x-select.vue?vue&type=template&id=38dc1070&"
import script from "./x-select.vue?vue&type=script&lang=js&"
export * from "./x-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports